module.exports = {
    DATE_FORMAT: 'DD.MM.YYYY',
    TIME_FORMAT: 'HH:mm',
    DATE_TIME_FORMAT: 'DD.MM.YYYY HH:mm:ss',
    DATE_TIME_FORMAT_SHORT: 'D MMM HH:mm',
    STANDARD_DATE_TIME_FORMAT: 'YYYY-MM-DD HH:mm:ss',
    DATE_FORMAT_OUTPUT: 'D MMMM YYYY',
}